import { FormValidator, isValidOnlyNumbers } from '~/modules';
import { isValidMaxLength } from '~/utils';

export const validationSchema = () =>
  FormValidator.object().shape({
    bank: FormValidator.string().required('Campo obrigatório'),
    agency: FormValidator.string()
      .required('Campo obrigatório')
      .test('agency', 'Apenas números', isValidOnlyNumbers),
    account: FormValidator.string()
      .required('Campo obrigatório')
      .test('agency', 'Apenas números', isValidOnlyNumbers),
    agencyDigit: FormValidator.string()
      .notRequired()
      .test('maxLength', 'Máximo de 2 dígitos', (value) =>
        isValidMaxLength(value ?? '', 2),
      ),
    accountDigit: FormValidator.string()
      .notRequired()
      .test('maxLength', 'Máximo de 2 dígitos', (value) =>
        isValidMaxLength(value ?? '', 2),
      ),
  });

export type CreditSimulationBankAccountFormValues = {
  agency: string;
  account: string;
  bank: string;
  agencyDigit?: string;
  accountDigit?: string;
};

export const initialValues: CreditSimulationBankAccountFormValues = {
  agency: '',
  account: '',
  bank: '',
};
